<template>
  <v-container>
    <PageHeader :title="name" />
    <v-card>
      <v-alert :value="!isAuthenticated" type="error" outline>
        Unauthorized, the page is only visible to system administrators. If you think you have system administrator credentials, try refreshing your page or notify support at envirodata-techsupport(at)hatfieldgroup.com
      </v-alert>
      <StaticContentHomePageCard :tenant-name="name" />
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const authenticate = createNamespacedHelpers('authenticate')
  const landingPageStaticContent = createNamespacedHelpers('landingPageStaticContent')

  import StaticContentHomePageCard from '@/components/LandingPageStaticContent/StaticContentHomePageCard'
  export default {
    components: {
      StaticContentHomePageCard,
    },
    props: {
      name: {
        type: String,
      },
    },
    computed: {
      ...authenticate.mapGetters(['isAuthed', 'isSystemAdmin']),
      ...landingPageStaticContent.mapState(['isReorderingItems']),
      isAuthenticated() {
        return this.isAuthed && this.isSystemAdmin
      },
    },
    methods: {
      ...landingPageStaticContent.mapMutations({
        resetLandingPageStaticContentStore: 'RESET',
      }),
    },
    beforeMount() {
      this.resetLandingPageStaticContentStore()
    },
    beforeDestroy() {
      this.resetLandingPageStaticContentStore()
    },
  }
</script>